import React, { useEffect, useState,useMemo } from "react";
import './QuestionCategoryNavigationBar.css';
import { Link } from 'react-router-dom';
import Navbar from '../navbar';
import Chart from "react-apexcharts";

function QuestionCategoryNavigationBar({buttonsList,urlPrefix,chartType}) {
const pageTitle = "ChartNavigationBar"
  function setChartType(button){

    localStorage.setItem("chartType",button.chartType)
    console.log("Chart Type "+localStorage.getItem("chartType"))
  }

  
  return (
   <div className="chartnavigationbar-container row">
  {buttonsList &&
    buttonsList.map((button) =>
      button.chartType === "stats" ? (
        // when chartType is "stats" -> just show static item
        <div
          key={button.title}
          className="chartnavigationbar-button col-md-2"
        >
          <img
            className="chartnavigationbar-button-icon"
            src={`/Assets/DataCentre/icons/${button.icon.toLowerCase()}.png`}
            alt={`${button.title} icon`}
          />
          <div className="chartnavigationbar-button-title">
            {button.title}
          </div>
          <div>[Statistic]</div>
        </div>
      ) : (
        // otherwise -> clickable Link
        <Link
          key={button.title}
          to={ button.chartType === "link" ? `${window.location.origin}/${button.linkTo}` : `${window.location.origin}/settings/questions/${button.categoryID}/${button.chartID}`}
          onClick={() => setChartType(button)}   // or setChartType(button.chartType)
          className="chartnavigationbar-button col-md-2"
        >
          <img
            className="chartnavigationbar-button-icon"
            src={`/Assets/DataCentre/icons/${button.icon.toLowerCase()}.png`}
            alt={`${button.title} icon`}
          />
          <div className="chartnavigationbar-button-title">
            {button.title}
          </div>
        </Link>
      )
    )}
</div>

  );
}

export default QuestionCategoryNavigationBar;
